export const getInputNumberValues = input => {
    return input.value.replace(/\D/g, "");
};
